import { AxiosInstance } from "axios"
import { CLIENT_TYPE } from "../../core/api/useAxios"
import { ClientConfiguration } from "./configTypes"

export enum ConfigPollerQuery {
    CLIENT_CONFIGURATION = "client-configuration",
}

export type ClientConfigurationResponse = Readonly<{
    config: ClientConfiguration
}>

export async function fetchClientConfiguration(
    params: Record<string, never>,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ClientConfigurationResponse> {
    const url = `/client/${CLIENT_TYPE}/config`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
